<template>
  <section id="dashboard-analytics">
    <b-row class="match-height">
      <b-col cols="12">
        <analytics-card title="Vuorojen tilaus/täyttö" end-point="getShiftsCompletion" />
        <analytics-map-card title="Tekijäkartta" />
        <!-- <analytics-application-updates /> -->
      </b-col>
    </b-row>
  </section>
</template>

<script>

import { BRow, BCol } from 'bootstrap-vue'
import AnalyticsCard from './AnalyticsCard.vue'
import AnalyticsMapCard from './AnalyticsMapCard.vue'
// import AnalyticsApplicationUpdates from './AnalyticsApplicationUpdates.vue'

export default {
  components: {
    BRow,
    BCol,
    AnalyticsCard,
    AnalyticsMapCard,
    // AnalyticsApplicationUpdates,
  },
  computed: {
    user() {
      return this.$store.state.appAuth.authUser ? this.$store.state.appAuth.authUser : {}
    },
  },
  async created() {
    this.$store.dispatch('appAuth/getCurrentUser')
      .then(res => {
        const user = JSON.parse(JSON.stringify(res))
        this.options = user
      })
      
    await this.$store.dispatch('appAccount/fetchAreaGroups')
  },
}
</script>